import { useEffect, useState } from 'react';

/**
 * DP56 — dark mode, read the way the app already reads it: the `dark` class on
 * <html>, mirrored into localStorage.keyMadeDarkMode. Same MutationObserver
 * pattern App.js already uses, so a toggle anywhere updates everywhere. No new
 * source of truth.
 */
export function useDarkMode() {
  const [darkMode, setDarkMode] = useState(
    () => document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDarkMode(document.documentElement.classList.contains('dark'));
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const toggleDarkMode = () => {
    const next = !document.documentElement.classList.contains('dark');
    document.documentElement.classList.toggle('dark', next);
    localStorage.setItem('keyMadeDarkMode', next.toString());
  };

  return { darkMode, toggleDarkMode };
}
